import React from 'react';
import { Auth } from 'aws-amplify';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {
  clearDataEmail,
  logoutUser,
} from '../../Actions/actions';
import loader from "../../images/Spin-1s-107px.gif";

class Logout extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  async componentDidMount() {
    await localStorage.clear();
    Auth.signOut()
      .then(async () => {
        await this.props.logoutUser();
        await this.props.clearDataEmail();
        this.props.history.push('/');
      })
      .catch(error => error);
  }

  render() {
    return (
      <div className="loader">
        <img src={loader} alt="" />
      </div>
    );
  }
}
const mapStateToProps = state => ({ data: state.data });
const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      logoutUser,
      clearDataEmail,
    },
    dispatch,
  );
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Logout));
